import { FC } from "react"
import DeviceCard from "./DeviceCard"

interface DeviceListProps {
  devices: {
    id: string
    name: string | null
    serialNumber: string
    type: string | null
    status: string
    location: string | null
    lastReading?: string
    lastUpdated: string | null
    batteryLevel: number
    signalStrength: number
    leakAlarms: number
  }[]
  deviceSearch: string
  deviceFilter: string
  deviceTypeFilter: string
}

const DeviceList: FC<DeviceListProps> = ({
  devices,
  deviceSearch,
  deviceFilter,
  deviceTypeFilter,
}) => {
  const filteredDevices = devices.filter((device) => {
    const matchesSearch =
      (device.name?.toLowerCase() || "").includes(deviceSearch.toLowerCase()) ||
      device.serialNumber.toLowerCase().includes(deviceSearch.toLowerCase())
    const matchesFilter =
      deviceFilter === "all" ||
      (deviceFilter === "alarms" && device.leakAlarms > 0) ||
      (deviceFilter === "normal" && device.leakAlarms === 0)
    const matchesType = deviceTypeFilter === "all" || device.type === deviceTypeFilter
    return matchesSearch && matchesFilter && matchesType
  })

  const hasManyDevices = filteredDevices.length > 6

  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-min ${
        hasManyDevices ? "max-h-[688px] overflow-y-auto pr-2" : "min-h-[688px]"
      }`}
    >
      {filteredDevices.length === 0 ? (
        <div className="col-span-1 md:col-span-2 lg:col-span-3 flex items-center justify-center min-h-[full] text-muted-foreground">
          No devices found
        </div>
      ) : (
        filteredDevices.map((device) => (
          <DeviceCard key={device.id} device={device} />
        ))
      )}
    </div>
  )
}

export default DeviceList
